<template>
  <v-navigation-drawer
    right
    temporary
    v-model="userNavVisible"
    fixed
  >
    <v-toolbar
      dark
      color="primary"
      flat
      class="user-nav">
      <v-avatar
        class="user-nav__avatar white"
        size="32"
      >
        <v-icon color="primary">person</v-icon>
      </v-avatar>
      <span
        v-if="isLoggedIn"
        :title="userData.username"
        class="ml-2 body-2 text-truncate"
      >{{ userData.username }}</span>
      <v-spacer />
      <v-btn
        icon
        class="ml-0"
        @click.native.stop="userNavVisible = false">
        <v-icon large>close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-list dense class="pt-0" v-if="isLoggedIn">
      <v-list-tile :href="`${siteUrls.userSite}/settings`" ripple v-once>
        <v-list-tile-action>
          <v-icon>settings</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Settings</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-list-tile :href="siteUrls.supportUrl" ripple v-once>
        <v-list-tile-action>
          <v-icon>headset_mic</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Help Center</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <v-divider />

      <v-list-tile href="/logout" ripple>
        <v-list-tile-action>
          <v-icon>lock</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Log out</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

    </v-list>

    <v-list dense class="pt-0" v-else>
      <v-list-tile href="/login" ripple>
        <v-list-tile-action>
          <v-icon>lock</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Log in</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import siteUrls from '@/helpers/site_urls'

  export default {
    data () {
      return {
        siteUrls
      }
    },
    computed: {
      ...mapState('layout', ['showUserNav']),
      ...mapGetters('user', ['isLoggedIn']),
      ...mapState('user', ['userData']),
      userNavVisible: {
        get () {
          return this.showUserNav
        },
        set (val) {
          this.$store.dispatch('layout/setUserNav', val)
        }
      }
    }
  }
</script>

<style lang="stylus">
  .user-nav
    &__avatar
      // Important is necessary to override an overly specific rule in vuetify
      margin-left: -6px !important
</style>



// WEBPACK FOOTER //
// frontend/src/components/core/AppUserNav.vue